import script from "./GGanttChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttChart.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttChart.vue?vue&type=style&index=0&id=cc5a4fb6&lang=css"

const __exports__ = script;

export default __exports__